export enum QuestionType {
  PassFail = 'passFail',
  MultipleChoice = 'multipleChoice',
  TextInput = 'textInput',
  NumberInput = 'numberInput',
  Property = 'property',
  DropdownSelection = 'dropdownSelection',
  IncrementEntry = 'incrementEntry',
  Measurement = 'measurement',
  // stored as singleUser / multiUser (userSelectionType)
  User = 'user'
}
